interface Props {
    width?: number
    height?: number
}

export function Spacer_Header({width, height}:Props){
    return(
        <div className="block w-full h-[82px]"></div>
    )
}